import { useEffect, useState } from 'react';
// import docImage from '../img/image2.jpg';
import docImage from '../img/image7.jpg';

const useService = () => {
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    // fetch('/fakeDocInfo.JSON')
    //   .then((res) => res.json())
    //   .then((data) => setDoctors(data));

    setDoctors(DoctorsData);
  }, []);

  return [doctors];
};
export default useService;

const DoctorsData = [
  {
    docId: '01',
    docName: 'Dr. Priyanka Yadav',
    // docPosition: 'Chief Medical Officer',
    docPosition: 'M.B.B.S , Master of Dermatology',
    docDegrees: 'M.B.B.S , Master of Dermatology',
    docExpertise:
      'Dermatologist, Cosmetologist, Venereologist, Trichologist, Pediatric (skin), Aesthetics    ',
    docContact: {
      mob: '+91 9910091720',
      email: 'drpriyankayadavdermatologist@gmail.com',
    },
    docDesc1:
      'Dr. Priyanka Yadav is a dermatologist with over 7 years of experience in the field of dermatology. Her passion for skincare and helping patients achieve healthy, radiant skin has driven her to become an expert in the field.',
    docDesc2:
      'Dr. Priyanka Yadav completed her medical degree and dermatology residency at a top-tier medical institution, where she gained extensive training and experience in diagnosing and treating a wide range of skin conditions.',
    // docImg: 'https://i.ibb.co/GnkZkC1/6.jpg',
    docImg: docImage,
    education: 'M.B.B.S , M.Derm',
    workDays: 'Weekdays',
    socialLink: [
      {
        instagram:
          'https://www.instagram.com/dermapera.skinbeyond/?igshid=ZDdkNTZiNTM%3D',
      },
      {
        facebook:
          'https://www.facebook.com/profile.php?id=100079858599172&mibextid=ZbWKwL',
      },
    ],
    experience: [
      {
        hospitalName: 'Royal Prince Alfred Hospital – Sydney',
        year: 'June 2009 to July 2010',
        description:
          "Royal Prince Alfred Hospital (RPA) was named after Queen Victoria's second son, His Royal Highness Prince Alfred, later Duke of Edinburgh. During a visit to Australia in 1868 Prince Alfred was the victim of an assassination attempt while on a picnic in the northern Sydney suburb of Clontarf.",
      },
    ],
  },
];

// 1. Scars treatment
// 2. Dark spots
// 4. Fillers and isme photo change
// 5. Lips Augmentation
// 6. Facial
// 7. Lesser hair removal
// 8. Hair growth
// 9. Others
